import styled from '@emotion/native';
import { Row } from 'components/base';
import { BASE_SIZE, PADDING } from 'design-system/theme';
import type React from 'react';
import type { ProfileProps } from '../shared';
import { Logo, Profile } from '../shared';

type TopBarProps = ProfileProps;

const Wrapper = styled(Row)(({ theme }) => ({
  flexDirection: 'row',
  backgroundColor: theme.color['base-grey'],
  justifyContent: 'space-between',
  paddingHorizontal: PADDING.s,
  height: BASE_SIZE[48],
  maxWidth: '100%',
}));

export const TopBar: React.FC<TopBarProps> = ({
  name,
  onProfilePress,
  ward,
  wards,
  onWardSelect,
}) => (
  <Wrapper unsetZIndex>
    <Logo />
    <Profile
      name={name}
      onProfilePress={onProfilePress}
      ward={ward}
      wards={wards}
      onWardSelect={onWardSelect}
    />
  </Wrapper>
);
